import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .heading {
    display: block;
    margin-bottom:  ${csSpacing.spacing06};
  }

  cse-fieldset {
    --cse-label-font-size: 14px;
  }
`
